// Creates a cookie for object-resolver header
export const createCookie = (userContext: string | undefined): string => {
	const cookieTarget =
		process.env.NODE_ENV === 'production' ? 'cloud.session.token' : 'cloud.session.token.stg';

	return `${cookieTarget}=${userContext}`;
};
